module.exports = __webpack_public_path__ + "img/MapThumb_Savannah.22c5ca0a.webp";